<template>
  <Feature :title="'Account List'" :iconClass="'fa-user-circle-o'">
    <FormRow :fieldNameArr="[$t('EC_GROUP_ACCOUNT'), '', $t('ROLE')]">
      <Input v-model="searchForm.groupAccount" slot="a" />
      <Button type="success" @click="moreGroupAccount" slot="b">{{ $t("MORE") }}</Button>
      <Select v-model="searchForm.roles" multiple slot="c">
        <Option v-for="item in roleList" :value="item.code" :key="item.code">{{ item.name }}</Option>
      </Select>
    </FormRow>
    <FormRow :fieldNameArr="[$t('GO_LIVE_DATE', '', $t('STATUS'))]">
      <DatePicker
        type="date"
        show-week-numbers
        placeholder="Select date"
        style="width: 200px"
        :value="searchForm.startDate"
        @on-change="changeDate('startDate', $event)"
        slot="a"
      ></DatePicker>
      <DatePicker
        type="date"
        show-week-numbers
        placeholder="Select date"
        style="width: 200px"
        :value="searchForm.endDate"
        @on-change="changeDate('endDate', $event)"
        slot="b"
      ></DatePicker>
    </FormRow>
    <FormRow :fieldNameArr="[$t('STATUS'), '', '']">
      <RadioGroup v-model="searchForm.status" size="large" slot="a">
        <Radio label="ALL">ALL</Radio>
        <Radio label="LOCK">LOCK</Radio>
        <Radio label="UNLOCK">UNLOCK</Radio>
      </RadioGroup>
      <Button type="primary" @click="search()" slot="b">{{ $t("QUERY") }}</Button>
      <div slot="c">
        <Button type="primary" @click="excelExport()">下載檔案</Button>
      </div>
    </FormRow>
    <TablePage
      :tableWidth="windowWidth"
      :columnsList="columnsList"
      :resultList="filterResultList"
      :pageObj="pageObj"
      :canChangeRow="false"
      size="small"
      @changePage="changePage"
      @changeSort="changeSort"
      @changeSearchValue="changeSearchValue"
    >
      <Modal
        :styles="{ top: '300px' }"
        v-model="moreGroupAccountModal"
        :title="$t('ACCOUNT_MORE')"
        @on-ok="confirmGroupAccounValue"
        :draggable="true"
        sticky
        :z-index="modalSize"
        :reset-drag-position="true"
      >
        <Input v-model="groupAccountValue" type="textarea" :rows="10" />
      </Modal>
    </TablePage>
  </Feature>
</template>

<script>
import { mapGetters } from "vuex"
import { list, download } from "../../util/api/vendor/delta-group-account"
import { searchAttribute } from "../../util/api/auth/role"
import { mapActions } from "vuex"
import { DownloadFile } from "../../util/common"

export default {
  name: "account-list",
  data: function() {
    const vueInstance = this
    return {
      query: "",
      searchForm: {
        groupAccount: "",
        roles: [],
        startDate: "",
        endDate: "",
        status: "ALL",
        codes: [],
        sort: "",
      },
      roleList: [],
      resultList: null,
      filterResultList: null,
      columnsList: [
        {
          title: vueInstance.$t("ACCOUNT"),
          width: 120,
          key: "code",
          align: "center",
        },
        {
          title: vueInstance.$t("ROLE"),
          width: 120,
          align: "center",
          key: "role",
        },
        {
          title: vueInstance.$t("REGION"),
          width: 200,
          align: "left",
          render: (h, params) => {
            const regions = params.row.regions?.map(region => {
              return h("p", region.description)
            })
            return h("div", regions)
          },
        },
        {
          title: vueInstance.$t("COMPANY_NAME"),
          width: 200,
          key: "companyName",
          align: "left",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("COUNTRY"),
          width: 120,
          key: "country",
          align: "center",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("STATUS"),
          width: 100,
          key: "isLock",
          align: "center",
          sortable: "custom",
          render: (h, params) => {
            return h("div", params.row.isLock ? "LOCK" : "UNLOCK")
          },
        },
        {
          title: vueInstance.$t("CREATE_DATE"),
          width: 140,
          key: "createdDate",
          align: "center",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("GO_LIVE_DATE"),
          width: 140,
          key: "effectiveDate",
          align: "center",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("LAST_CHANGE_DATE"),
          width: 160,
          key: "lastChangeDate",
          align: "center",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("OFF_LIVE_DATE"),
          width: 140,
          key: "offLiveDate",
          align: "center",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("OFF_LIVE_REASON"),
          width: 150,
          key: "offLiveReason",
          align: "center",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("REMARK"),
          width: 120,
          key: "remarks",
          align: "center",
          sortable: "custom",
        },
        {
          title: vueInstance.$t("EXCEPTION"),
          width: 140,
          key: "exception",
          align: "center",
        },
        {
          title: vueInstance.$t("AGREE_TERMS"),
          width: 140,
          key: "agreeTerms",
          align: "center",
        },
        {
          title: vueInstance.$t("EMAIL"),
          width: 300,
          align: "center",
          render: (h, params) => {
            const emails = params.row.emails?.map(email => {
              return h("p", email)
            })
            return h("div", emails)
          },
        },
      ],
      pageObj: {
        page: 0,
        totalPage: 0,
        totalCount: 0,
        pageSize: 10,
      },
      moreGroupAccountModal: false,
      groupAccountValue: "",
    }
  },
  methods: {
    ...mapGetters(["getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    moreGroupAccount: function() {
      this.$refs.modal.show()
    },
    changeDate: function(key, value) {
      this.searchForm[key] = value
    },
    search(page = 0) {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.searchForm.unPage = true
      vueInstance.searchForm.page = page
      /// Query For List
      vueInstance.searchForm.size = 10
      list(vueInstance, vueInstance.searchForm)
        .then(function(res) {
          if (res.status === 200) {
            vueInstance.pageObj = {
              page: page + 1,
              pageSize: res.data.page.size,
              totalPage: res.data.page.totalPages,
              totalCount: res.data.page.totalElements,
            }
            if (res.data?._embedded?.accountListResourceList) {
              vueInstance.resultList = res.data?._embedded?.accountListResourceList
              vueInstance.resultList.forEach(item => {
                item.emailList = item.emails
                  ?.map(o => {
                    return o.email
                  })
                  .join("")
                item.regionList = item.regions
                  ?.map(o => {
                    return o.description
                  })
                  .join("")
                item.isLockString = item.isLock ? "LOCK" : "UNLOCK"
              })

              vueInstance.filterResultList = vueInstance.resultList.filter(function(o) {
                return Object.keys(o).some(function(k) {
                  return (
                    o[k]
                      .toString()
                      .toLowerCase()
                      .indexOf(vueInstance.query.toLowerCase()) != -1
                  )
                })
              })
            } else {
              vueInstance.resultList = []
              vueInstance.filterResultList = []
            }
          } else {
            vueInstance.resultList = []
            vueInstance.filterResultList = []
          }
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    excelExport() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      download(vueInstance, vueInstance.searchForm)
        .then(function(res) {
          const blob = new Blob([res.data])
          DownloadFile(blob, res.headers["content-disposition"].split('"')[1])
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    changePage(page) {
      this.search(page - 1)
    },
    changeSort(query) {
      const vueInstance = this
      if (query.order == "normal") {
        vueInstance.searchForm.sort = ""
      } else {
        vueInstance.searchForm.sort = query.key + "," + query.order
      }
      this.search(0)
    },
    changeSearchValue(query) {
      const vueInstance = this
      vueInstance.query = query
      vueInstance.filterResultList = vueInstance.resultList.filter(function(o) {
        return Object.keys(o).some(function(k) {
          if (o[k]) {
            return (
              o[k]
                ?.toString()
                .toLowerCase()
                .indexOf(vueInstance.query.toLowerCase()) !== -1
            )
          } else {
            return false
          }
        })
      })
    },
    moreGroupAccount() {
      this.moreGroupAccountModal = true
      this.searchForm.groupAccount = ""
    },
    confirmGroupAccounValue() {
      this.groupAccountValue.split("\n").forEach(a => {
        this.searchForm.groupAccount = this.searchForm.groupAccount.concat(a + ";")
      })
      this.searchForm.groupAccount = this.searchForm.groupAccount.substr(0, this.searchForm.groupAccount.length - 1)
    },
  },
  mounted() {
    const vueInstance = this
    searchAttribute(vueInstance, {
      attributeDtos: [
        {
          key: "GROUP_PERSON",

          value: "Group",
        },

        {
          key: "MAIN_ROLE",

          value: "Y",
        },
      ],

      paged: false,
    }).then(res => {
      vueInstance.roleList = res.data?._embedded?.roleResourceList
    })
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}
</script>
